import { Small } from '@/shared/ui/components/Typography';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { Chip, Stack } from '@mui/material';

type Props = {
  label: string;
  questions: string[];
  /** Asks the question as a new turn. */
  onAsk: (question: string) => void;
};

/** Questions the agent says it can answer, one click to ask. */
const SuggestedQuestions = ({ label, questions, onAsk }: Props) => {
  if (questions.length === 0) return null;

  return (
    <Stack spacing={0.75}>
      <Small color="text.secondary">{label}</Small>
      <Stack direction="row" useFlexGap spacing={1} sx={{ flexWrap: 'wrap' }}>
        {questions.map(question => (
          <Chip
            key={question}
            clickable
            variant="outlined"
            color="primary"
            icon={<SubdirectoryArrowRightIcon fontSize="small" />}
            label={question}
            onClick={() => onAsk(question)}
            sx={{ height: 'auto', py: 0.5, '& .MuiChip-label': { whiteSpace: 'normal' } }}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default SuggestedQuestions;
